/**
 * Messages actions
 */
import { dispatch } from 'store';

import { MESSAGES_COUNT_SET, NOTIFICATIONS_COUNT_SET } from '../action-types/messages.action-types';

// eslint-disable-next-line import/prefer-default-export
export const setMessagesCountData = (data) => dispatch({ type: MESSAGES_COUNT_SET, data });

export const setNotificationsCountData = (data) => dispatch({ type: NOTIFICATIONS_COUNT_SET, data });
